"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverErrorUserFeedback = void 0;
const locales_1 = require("../enums/locales");
exports.serverErrorUserFeedback = {
    couldNotGetTicketingOccurrences: {
        [locales_1.Locales.EN]: "Could not get ticketing occurrences",
        [locales_1.Locales.FR]: "Impossible de récupérer les occurrences de billetterie",
    },
    errorTest: {
        [locales_1.Locales.EN]: "Error test",
        [locales_1.Locales.FR]: "Erreur de test",
    },
};
